import EmployeeSalaryAbsenceDeductComponents from "../components/EmployeeSalaryAbsenceDeduct";
import useEmployeeSalaryAbsenceDeduct from "../hooks/useEmployeeSalaryAbsenceDeduct";

function EmployeeSalaryAbsenceDeduct() {
  const employeeSalaryAbsenceDeductProps = useEmployeeSalaryAbsenceDeduct();
  return (
    <EmployeeSalaryAbsenceDeductComponents
      {...employeeSalaryAbsenceDeductProps}
    />
  );
}

export default EmployeeSalaryAbsenceDeduct;
